import styled from '@emotion/styled';
import type { HTMLAttributes } from 'react';
import { Checkbox } from '../checkbox';
import { Typography } from '../typography';

type ChallengeCheckboxProps = HTMLAttributes<HTMLDivElement> & {
  label: string;
  checked: boolean;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  size?: 'sm' | 'md';
};

const CheckAction = styled('div')<{ size: 'sm' | 'md' }>`
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border-radius: 4px;
  min-width: ${({ size }) => (size === 'md' ? '40px' : '32px')};
  width: fit-content;
  height: ${({ size }) => (size === 'md' ? '40px' : '32px')};
  background-color: ${({ theme }) =>
    theme.tokens.color.global.neutral.neutral100.value};
  padding-left: ${({ size }) => (size === 'md' ? '10px' : '8px')};
  padding-right: ${({ size }) => (size === 'md' ? '10px' : '8px')};

  #challenge-checkbox-text {
    font-size: 0;
    opacity: 0;
  }

  &:hover {
    background-color: ${({ theme }) => theme.colors.dark['05']};

    #challenge-checkbox-text {
      visibility: visible;
      opacity: 1;
      transition: font-size 0.1s linear;
      font-size: 12px;
      margin-right: 8px;
    }
  }
`;

function ChallengeCheckbox({
  label,
  checked,
  onChange,
  size = 'md',
  ...rest
}: ChallengeCheckboxProps): JSX.Element {
  return (
    <CheckAction
      size={size}
      data-testid="challenge-checkbox"
      {...rest}
      onClick={(e) => e.stopPropagation()}
    >
      <Typography.Subtitle2 id="challenge-checkbox-text">
        {label}
      </Typography.Subtitle2>
      <Checkbox
        checked={checked}
        onCheck={(value) => {
          const event = {
            target: { checked: value },
          } as React.ChangeEvent<HTMLInputElement>;
          onChange(event);
        }}
      />
    </CheckAction>
  );
}

export { ChallengeCheckbox };
export type { ChallengeCheckboxProps };
